import { Icon } from "@chakra-ui/icons"
import React from "react"

const PhoneBoldIcon = props => {
  return (
    <Icon viewBox="0 0 15.73 15.73" {...props}>
      <g>
        <path
          d="M9.54 6.83H8.18v2.66a1 1 0 00.17.66.68.68 0 00.55.2h.31a2 2 0 00.29-.08v.83a2.34 2.34 0 01-.4.1 2.38 2.38 0 01-.46 0 1.44 1.44 0 01-1.11-.4 1.67 1.67 0 01-.39-1.2V6.83h-1V6h1V4.52h1V6h1.4z"
          fill="currentColor"
        />
        <path
          d="M15.23 15.23H.5V.5h14.73z"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
      </g>
    </Icon>
  )
}

export default PhoneBoldIcon
